module.exports = __webpack_public_path__ + "img/cookie-policy-img.a34237f7.webp";